<basic-input
  [prefixSlug]="prefixSlug"
  [control]="control"
  [icon]="icon"
  [label]="label"
  iconType="stroke"
  [id]="id"
  [required]="required"
  [fieldType]="basicFieldType"
  (onBlurValueChange)="onBlurEvent($event)"
></basic-input>
